import { getUserAndEventTime } from './get-user-and-event-time.js';
import { getCompany } from './get-company.js';
import { getTaskAndTaskWorkflow } from './get-task-and-task-workflow.js';
import { getAuthenticationMethod } from './get-authentication-method.js';
export const getDefaultProperties = () => {
    return {
        ...getUserAndEventTime(),
        publicToken: '09601c31-1b54-4855-12ec-81810de154bd',
        ...getAuthenticationMethod(),
        ...getCompany(),
        ...getTaskAndTaskWorkflow()
    };
};
//# sourceMappingURL=get-default-properties.js.map